import React, { Component } from "react";
import { formDataSchema } from "../../../../schema/add-user";
import { serviceSchema } from "../../../../schema/add-service";
import { unitForm } from "../../../../schema/units";
import { doctorForm } from "./../../../../schema/doctors";
import { tvForm } from "./../../../../schema/tvScreen";
import { addRoleSchema } from "../../../../schema/add-role";
import { serviceGroupForm } from "../../../../schema/serviceGroup";
import { workStationsForm } from "../../../../schema/workStations";
import Datepicker from "../../../../components/FormComponent/Date";
import Select2multiple from "../../../../components/FormComponent/select2/multiple";
import TimepickerLayer from "../../../../components/FormComponent/TimePickerLayer";
import Select2 from "../../../../components/FormComponent/select2";
import Inputlayer from "../../../../components/FormComponent/Input";
import networkList from "./../../../../constants/networkList";
import postService from "./../../../../services/httpService";
import { Empty, Modal, Select, Spin, Upload, Tooltip, message } from "antd";
import userTrackService from "./../../../../services/usertrack-service";
import Storage from '../../../../services/local-store';
import { CloudUploadOutlined } from '@ant-design/icons';
import formDataPostService from "../../../../services/httpformData";

const $ = require("jquery");
const { Option } = Select
class Add_User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadding: false,
      visible: false,
      formData: [],
      addText: "",
      showPrevilages: false,
      active_units: [],
      fetching: false,
      mappedUnits: [],
      fileList: [],
      doctorData: [],
      unit_id:'',
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  componentDidMount() {
    console.log("user details",JSON.parse(localStorage.getItem("user_data")));
    let userdata=JSON.parse(localStorage.getItem("user_data"));
    this.setState({unit_id:userdata.unitid});
    console.log("unitid",userdata.unitid);
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    let { slug } = this.props.match.params;
  
    const {
      getUserDetailsById,
      getDoctorIdDetails,
      getWorkStationDetails,
      blockDetails,
      floorDetails,
      OTRoomsDetails,
      getProceduresById,
      getTvById,
    } = networkList;
    let formSchema = Object.assign({}, formDataSchema);
    let servicesSchema = Object.assign({}, serviceSchema);
    let tvformSchema = Object.assign({}, tvForm);
    let unitformSchema = Object.assign({}, unitForm);
    let roleSchema = Object.assign({}, addRoleSchema);
    let serviceGroupSchema = Object.assign({}, serviceGroupForm);
    let workStationsSchema = Object.assign({}, workStationsForm);
    switch (slug) {
      case "add-user":
        this.getMapped_UnitsOfUser();

        formSchema["feilds"].map((feild, key) => {
          formSchema["feilds"][key]["value"] = null;
          formSchema["feilds"][key]["disable"] = false;
          formSchema["feilds"][key]["valid"] = false;
          formSchema["feilds"][key]["errors"] = [];
          if (feild["name"] === "work_station") {
            feild["value"] = null;
            feild.visible = false;
          }
          if (feild["name"] === "rh_userid") {
            feild["value"] = null;
            feild.visible = false;
          }
          delete formSchema["feilds"][key]["text"];
        });

        this.setState({
          addText: "Add User",
          buttonText: "Submit",
          formData: formSchema["feilds"],
        });
        break;
      case "edit-user":
        this.getMapped_UnitsOfUser()
        this.setState(
          (state) => ({
            addText: "Edit User",
            buttonText: "Update",
            rid: rid,
            formData: formSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Edit User - Request",
              date: new Date(),
              meta: { id: rid },

            };
          
            userTrackService(Userlogobj);
            postService(getUserDetailsById, "POST", { data: { id: rid } }).then(
              (res) => {
                let Userlogobjres = {
                  user: JSON.parse(localStorage.getItem("user")),
                  action: "Edit User - Response",
                  date: new Date(),
                  meta: res,
                };

                userTrackService(Userlogobjres);
                // console.log('response',res.data[0]);
                if (res.status) {
                  let newData = [];
                  let unitids = [];
                  res.data[0]["unitids"].map(unitdetails => {
                    unitids.push(unitdetails['unit_id'])
                    newData.push({
                      'id': unitdetails['unit_id'],
                      'name': unitdetails['unitname']
                    })
                  })
                  this.setState({ active_units: unitids })
                  // this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                  formSchema["feilds"].map((feild, key) => {
                    if (feild["name"] === "name") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["username"];
                    }
                    if (feild["name"] === "userName") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["username"];
                    }
                    if (feild["name"] === "rh_userid") {
                      formSchema["feilds"][key]["value"] = res.data[0]["rh_userid"];
                      feild.visible = true;
                      formSchema["feilds"][key]["disable"] = true;
                    }
                    if (feild["name"] === "role") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["rolename"];
                      formSchema["feilds"][key]["text"] =
                        res.data[0]["rolename"];
                    }
                    if (feild["name"] === "gender") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["gender"];
                      formSchema["feilds"][key]["text"] = res.data[0]["gender"];
                    }
                    if (feild["name"] === "unit") {
                      localStorage.setItem('workstationbyunitid', parseInt(res.data[0]["unitids"][0]['unit_id']))
                      // formSchema["feilds"][key]["value"] =
                      //   res.data[0]["unitids"];
                      // formSchema["feilds"][key]["text"] =
                      //   res.data[0]["unitname"];

                      formSchema["feilds"][key]["value"] = res.data[0]["unitids"].map((unit) => unit.unit_id);
                      formSchema["feilds"][key]["text"] = res.data[0]["unitids"].map((unit) => unit.unitname);
                      formSchema["feilds"][key]["disable"] = true;
                    }
                    if (feild["name"] === "role") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["roleid"];
                      formSchema["feilds"][key]["text"] =
                        res.data[0]["rolename"];
                      formSchema["feilds"][key]["disable"] = true;
                      // const user_data = JSON.parse(localStorage.getItem("user_data"));
                      
                      // console.log("-------------------------------",user_data);

                      // console.log("--------------------------" , user_data.role_name);

                      // console.log("------------------" , user_data.roleid);
                      // //debugger
                      // if(user_data.roleid === "RL_ifmK"){
                      //   formSchema["feilds"][key]["disable"] = false;
                      // }
                      // else if(user_data.roleid === "RL_ijmN"){
                      //   formSchema["feilds"][key]["disable"] = false;
                      // }
                      // else {
                      //   formSchema["feilds"][key]["disable"] = true;
                      // }
                      

                      let previlageArray = [];
                      if (res.data[0]["roleid"] === "RL_GXCM") {
                        let { formData } = this.state;

                        formData.map((feild, key) => {
                          if (feild["id"] > 11) {
                            delete formData[key];
                          }
                          if (formData[key]["name"] === "otroom") {
                            formData[key]["visible"] = true;
                          }
                        });

                        this.setState(
                          (state) => ({
                            formData: formData,
                            showPrevilages: false,
                          }),
                          () => { }
                        );
                      } else {
                        let { formData } = this.state;
                        formData.map((feild, key) => {
                          if (feild["id"] > 11) {
                            delete formData[key];
                          }
                          if (formData[key]["name"] === "otroom") {
                            formData[key]["visible"] = false;
                            formData[key]["value"] = [];
                            formData[key]["rules"] = [];
                          }
                        });

                        this.setState((state) => ({
                          formData: formData,
                          showPrevilages: false,
                        }));
                      }
                    }

                    if (res.data[0]["roleid"] === "RL_wVbj") {
                      let { formData } = this.state;

                      formData.map((feild, key) => {
                        if (feild["id"] > 11) {
                          delete formData[key];
                        }
                        if (formData[key]["name"] === "doctor_id") {
                          formData[key]["visible"] = true;
                        }
                      });

                      this.setState(
                        (state) => ({
                          formData: formData,
                          showPrevilages: false,
                        }),
                        () => { }
                      );
                    } else {
                      let { formData } = this.state;
                      formData.map((feild, key) => {
                        if (feild["id"] > 11) {
                          delete formData[key];
                        }
                        if (formData[key]["name"] === "doctor_id") {
                          formData[key]["visible"] = false;
                          formData[key]["value"] = null;
                          formData[key]["rules"] = [];
                        }
                      });

                      this.setState((state) => ({
                        formData: formData,
                        showPrevilages: false,
                      }));
                    }
                    if (res.data[0]["roleid"] === "RL_LiGM") {
                      let { formData } = this.state;
                      formData.map((feild, key) => {
                        if (feild["id"] > 11) {
                          delete formData[key];
                        }
                        if (formData[key]["name"] === "secretary_doctor_ids") {
                          formData[key]["visible"] = true;
                        }
                      });

                      this.setState(
                        (state) => ({
                          formData: formData,
                          showPrevilages: false,
                        }),
                        () => { }
                      );
                    } else {
                      let { formData } = this.state;
                      formData.map((feild, key) => {
                        if (feild["id"] > 11) {
                          delete formData[key];
                        }
                        if (formData[key]["name"] === "secretary_doctor_ids") {
                          formData[key]["visible"] = false;
                          formData[key]["value"] = null;
                          formData[key]["rules"] = [];
                        }
                      });

                      this.setState((state) => ({
                        formData: formData,
                        showPrevilages: false,
                      }));
                    }

                    // if (
                    //   res.data[0]["roleid"] === "RL_ijmN" ||
                    //   res.data[0]["roleid"] === "RL_uxwJ"
                    // ) {
                    //   let { formData } = this.state;
                    //   formData.map((feild, key) => {
                    //     if (feild["id"] > 11) {
                    //       delete formData[key];
                    //     }
                    //     if (formData[key]["name"] === "unit") {
                    //       if (formData[key]["element"] === "Select2multiple") {
                    //         formData[key]["visible"] = true;
                    //         formData[key]["value"] = res.data[0]["unitids"];
                    //         formData[key]["text"] = res.data[0]["unitids"].map(
                    //           (unit) => unit.unitname
                    //         );
                    //       }
                    //       if (formData[key]["element"] === "select2") {
                    //         formData[key]["visible"] = false;
                    //       }
                    //     }
                    //   });
                    //   this.setState(
                    //     (state) => ({
                    //       formData: formData,
                    //       showPrevilages: false,
                    //     }),
                    //     () => { }
                    //   );
                    // } else {
                    //   let { formData } = this.state;
                    //   formData.map((feild, key) => {
                    //     if (feild["id"] > 11) {
                    //       delete formData[key];
                    //     }
                    //     if (
                    //       formData[key]["name"] === "unit" &&
                    //       formData[key]["element"] === "Select2multiple"
                    //     ) {
                    //       formData[key]["visible"] = false;
                    //     }
                    //     if (
                    //       formData[key]["name"] === "unit" &&
                    //       formData[key]["element"] === "select2"
                    //     ) {
                    //       formData[key]["visible"] = true;
                    //       formData[key]["value"] = res.data[0]["unitids"];
                    //       formData[key]["text"] = res.data[0]["unitids"].map(
                    //         (unit) => unit.unitname
                    //       );
                    //     }
                    //   });

                    //   this.setState((state) => ({
                    //     formData: formData,
                    //     showPrevilages: false,
                    //   }));
                    // }

                    if (feild["name"] === "otroom") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["ot_rooms"];
                    }
                    if (feild["name"] === "doctor_id") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["doctor_id"];
                    }
                    if (feild["name"] === "user_id") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["userid"];
                      formSchema["feilds"][key]["disable"] = true;
                    }
                    if (feild["name"] === "password") {
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["password"];
                      formSchema["feilds"][key]["disable"] = true;
                    }
                    if (feild["name"] === "secretary_doctor_ids") {
                      // formSchema['feilds'][key]['value'] =res.data[0]['secretary_doctor_ids'];
                      formSchema["feilds"][key]["value"] =
                        res.data[0]["secretary_doctor_ids"];
                      formSchema["feilds"][key]["text"] =
                        res.data[0]["secretary_doctor_ids"];
                    }
                    if (res.data[0]["roleid"] === 'RL_J88m') {
                      if (feild["name"] === 'work_station') {
                        formSchema["feilds"][key]["value"] =
                          res.data[0]["work_station_id"];
                        formSchema["feilds"][key]["text"] =
                          res.data[0]["work_station_name"];
                        formSchema["feilds"][key]["visible"] = true;
                        formSchema["feilds"][key]["disable"] = false;
                      }
                    } else {
                      if (feild["name"] === 'work_station') {
                        formSchema["feilds"][key]["visible"] = false;
                      }
                    }
                  });
                  this.setState({
                    addText: "Edit User",
                    buttonText: "Update",
                    formData: formSchema["feilds"],
                  });
                }
              }
            );
          }
        );
        break;
      case "add-doctor":
        doctorForm["feilds"].map((feild, key) => {
          doctorForm["feilds"][key]["value"] = null;
          doctorForm["feilds"][key]["disable"] = false;
          doctorForm["feilds"][key]["valid"] = false;
          doctorForm["feilds"][key]["errors"] = [];
          delete doctorForm["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Doctor",
          buttonText: "Submit",
          formData: doctorForm["feilds"],
        });
        break;
      case "edit-doctor":
        this.setState(
          (state) => ({
            addText: "Edit Doctor",
            buttonText: "Update",
            formData: doctorForm["feilds"],
          }),
          () => {
            postService(getDoctorIdDetails, "POST", {
              data: { id: Number(rid) },
            }).then((res) => {
              if (res.status) {
                doctorForm["feilds"].map((feild, key) => {
                  if (feild["name"] === "doctorname") {
                    doctorForm["feilds"][key]["value"] = res.data[0]["name"];
                  }
                  if (feild["name"] === "empid") {
                    doctorForm["feilds"][key]["value"] =
                      res.data[0]["doctor_id"];
                    doctorForm["feilds"][key]["disable"] = true;
                  }
                  if (feild["name"] === "unit") {
                    doctorForm["feilds"][key]["value"] =
                      res.data[0]["unit_code"];
                    doctorForm["feilds"][key]["text"] = res.data[0]["unitname"];
                  }
                  if (feild["name"] === "specialization") {
                    doctorForm["feilds"][key]["value"] =
                      res.data[0]["specialization_code"];
                  }
                  // if (feild["name"] === "speciality_id") {
                  //   doctorForm["feilds"][key]["value"] =
                  //     res.data[0]["speciality_id"];
                  //   doctorForm["feilds"][key]["text"] =
                  //     res.data[0]["speciality_name"];
                  // }
                  if (feild["name"] === "department") {
                    // doctorForm['feilds'][key]['value'] = res.data[0]['department_id'];
                    // doctorForm["feilds"][key]["text"] =
                    //   res.data[0]["department_id"];

                    doctorForm["feilds"][key]["value"] =
                      res.data[0]["fk_department_id"];
                    doctorForm["feilds"][key]["text"] =
                      res.data[0]["departmentname"];
                    doctorForm["feilds"][key]["disable"] = true;
                  }
                  if (feild["name"] === "experience") {
                    doctorForm["feilds"][key]["value"] =
                      res.data[0]["experience"];
                  }
                  if (feild["name"] === "vitals_required") {
                    doctorForm["feilds"][key]["value"] =
                      res.data[0]["vitals_required"];
                  }

                });

                this.setState({
                  addText: "Edit Doctor",
                  buttonText: "Update",
                  formData: doctorForm["feilds"],
                  doctorData: res.data[0]
                });
              }
            });
          }
        );
        break;
      case "addtvscreen":
        tvformSchema["feilds"].map((feild, key) => {
          tvformSchema["feilds"][key]["value"] = null;
          tvformSchema["feilds"][key]["disable"] = false;
          tvformSchema["feilds"][key]["valid"] = false;
          tvformSchema["feilds"][key]["errors"] = [];
          if (feild["name"] === "queues-list") {
            feild.visible = false;
          }
          delete tvformSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add New Tv-Display Screen",
          buttonText: "Submit",
          formData: tvformSchema["feilds"],
        });
        break;
      case "edittvscreen":
        // this.setState(
        //   (state) => ({
        //     addText: "Edit Tv screen",
        //     buttonText: "Update",
        //     formData: tvformSchema["feilds"],
        //   }),
        //   () => {
        postService(getTvById, "POST", {
          data: { tv_display_id: rid },
        }).then((res) => {
          if (res.status) {
            tvformSchema["feilds"].map((feild, key) => {
              if (feild["name"] === "displayName") {
                tvformSchema["feilds"][key]["value"] =
                  res.data[0]["display_name"];
                tvformSchema["feilds"][key]["tv_id"] = res.data[0]["id"];
              }
              if (feild["name"] === "unit") {
                tvformSchema["feilds"][key]["value"] = res.data[0]["unit"];
                tvformSchema["feilds"][key]["text"] = res.data[0]["unit_name"];
              }
              if (feild["name"] === "qCreateType") {
                let qtype =
                  res.data[0]["queue_type"] === "billing"
                    ? "Billing"
                    : res.data[0]["queue_type"] === "opdconsultation"
                      ? "OPD Consultation"
                      : res.data[0]["queue_type"] === "radiology" && "Radiology";

                tvformSchema["feilds"][key]["value"] =
                  res.data[0]["queue_type"];
                tvformSchema["feilds"][key]["text"] = qtype;
              }
              if (feild["name"] === "queues-list") {
                let qlistIds = res.data[0]["queue_list"].map(
                  (ql) => ql.queue_list_id
                );
                let qlistNames = res.data[0]["queue_list"].map(
                  (ql) => ql.queue_list_name
                );
                tvformSchema["feilds"][key]["value"] = qlistIds && qlistIds;
                tvformSchema["feilds"][key]["text"] = qlistNames && qlistNames;
              }
              if (feild["name"] === "workstation") {
                tvformSchema["feilds"][key]["value"] =
                  res.data[0]["work_station"];
                tvformSchema["feilds"][key]["text"] =
                  res.data[0]["work_station"];
              }
            });
            this.setState({
              addText: "Edit Tv screen",
              buttonText: "Update",
              formData: tvformSchema["feilds"],
            });
          } else {
            this.setState((state) => ({
              addText: "Edit Tv screen",
              buttonText: "Update",
              formData: tvformSchema["feilds"],
            }));
          }
        });
        // }
        // );
        break;
      case "add-role":
        roleSchema["feilds"].map((feild, key) => {
          roleSchema["feilds"][key]["value"] = null;
          roleSchema["feilds"][key]["disable"] = false;
          roleSchema["feilds"][key]["valid"] = false;
          roleSchema["feilds"][key]["errors"] = [];

          delete roleSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Role",
          buttonText: "Submit",
          formData: roleSchema["feilds"],
        });
        break;
      case "edit-role":
        this.setState(
          (state) => ({
            addText: "Edit Role",
            buttonText: "Update",
            rid: rid,
            formData: roleSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Edit Role - Request",
              date: new Date(),
              meta: { id: rid },
            };
            userTrackService(Userlogobj);
            return false;
            postService("", "POST", { data: { id: rid } }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "Edit Role - Response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              // console.log('response',res.data[0]);
              if (res.status) {
                // this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                roleSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "name") {
                    roleSchema["feilds"][key]["value"] =
                      res.data[0]["username"];
                  }
                });
                this.setState({
                  addText: "Edit Role",
                  buttonText: "Update",
                  formData: roleSchema["feilds"],
                });
              }
            });
          }
        );
        break;
      case "add-service-group":
        serviceGroupSchema["feilds"].map((feild, key) => {
          serviceGroupSchema["feilds"][key]["value"] = null;
          serviceGroupSchema["feilds"][key]["disable"] = false;
          serviceGroupSchema["feilds"][key]["valid"] = false;
          serviceGroupSchema["feilds"][key]["errors"] = [];

          delete serviceGroupSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Service Group",
          buttonText: "Submit",
          formData: serviceGroupSchema["feilds"],
        });
        break;
      case "edit-service-group":
        this.setState(
          (state) => ({
            addText: "Edit Service Group",
            buttonText: "Update",
            rid: rid,
            formData: serviceGroupSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Edit User - Request",
              date: new Date(),
              meta: { id: rid },
            };
            userTrackService(Userlogobj);
            return false;
            postService(getUserDetailsById, "POST", { data: { id: rid } }).then(
              (res) => {
                let Userlogobjres = {
                  user: JSON.parse(localStorage.getItem("user")),
                  action: "Edit User - Response",
                  date: new Date(),
                  meta: res,
                };
                userTrackService(Userlogobjres);
                // console.log('response',res.data[0]);
                if (res.status) {
                  // this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                  serviceGroupSchema["feilds"].map((feild, key) => {
                    if (feild["name"] === "name") {
                      serviceGroupSchema["feilds"][key]["value"] =
                        res.data[0]["username"];
                    }
                  });
                  this.setState({
                    addText: "Edit Service Group",
                    buttonText: "Update",
                    formData: serviceGroupSchema["feilds"],
                  });
                }
              }
            );
          }
        );
        break;
      case "add-work-stations":
        workStationsSchema["feilds"].map((feild, key) => {
          workStationsSchema["feilds"][key]["value"] = null;
          workStationsSchema["feilds"][key]["disable"] = false;
          workStationsSchema["feilds"][key]["valid"] = false;
          workStationsSchema["feilds"][key]["errors"] = [];
          delete workStationsSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Work Station",
          buttonText: "Submit",
          formData: workStationsSchema["feilds"],
        });
        break;
      case "edit-work-stations":
        this.setState(
          (state) => ({
            addText: "Edit work Stations",
            buttonText: "Update",
            rid: rid,
            formData: workStationsSchema["feilds"],
          }),
          () => {
            postService(getWorkStationDetails, "POST", {
              id: Number(rid),
            }).then((res) => {
              if (res.status) {
                workStationsSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "unit_id") {
                    workStationsSchema["feilds"][key]["value"] =
                      res.data[0]["unit_id"];
                    workStationsSchema["feilds"][key]["text"] =
                      res.data[0]["unitname"];
                  }
                  if (feild["name"] === "work_station_name") {
                    workStationsSchema["feilds"][key]["value"] =
                      res.data[0]["work_station_name"];
                    workStationsSchema["feilds"][key]["text"] =
                      res.data[0]["work_station_name"];
                  }
                  if (feild["name"] === "cabin_count") {
                    workStationsSchema["feilds"][key]["value"] =
                      res.data[0]["cabin_count"];
                  }
                });
                this.setState({
                  addText: "Edit Work Station",
                  buttonText: "Update",
                  formData: workStationsSchema["feilds"],
                });
              }
            });

          }
        );
        break;
      case "add-departments":
        formSchema["feilds"].map((feild, key) => {
          formSchema["feilds"][key]["values"] = null;
          formSchema["feilds"][key]["disable"] = false;
          formSchema["feilds"][key]["valid"] = false;
          formSchema["feilds"][key]["errors"] = [];

          delete formSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Department",
          buttonText: "Submit",
          formData: formSchema["feilds"],
        });
        break;
      case "edit-departments":
        this.setState(
          (state) => ({
            addText: "Edit Department",
            buttonText: "Update",
            rid: rid,
            formData: formSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Edit department - Request",
              date: new Date(),
              meta: { id: rid },
            };
            userTrackService(Userlogobj);
            return false;
            postService("", "POST", { data: { id: rid } }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "Edit department - Response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              // console.log('response',res.data[0]);
              if (res.status) {
                // this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                formSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "name") {
                    formSchema["feilds"][key]["value"] =
                      res.data[0]["username"];
                  }
                });
                this.setState({
                  addText: "Edit Department",
                  buttonText: "Update",
                  formData: formSchema["feilds"],
                });
              }
            });
          }
        );
        break;
      case "add-services":

        servicesSchema["feilds"].map((feild, key) => {

          servicesSchema["feilds"][key]["value"] = null;
          servicesSchema["feilds"][key]["disable"] = false;
          servicesSchema["feilds"][key]["valid"] = false;
          servicesSchema["feilds"][key]["errors"] = [];

          delete servicesSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Service",
          buttonText: "Submit",
          formData: servicesSchema["feilds"],
        });
        break;
      case "edit-services":
        this.setState(
          (state) => ({
            addText: "Edit Service",
            buttonText: "Update",
            rid: rid,
            formData: servicesSchema["feilds"],
          }),
          () => {
            let Userlogobj = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Edit Service - Request",
              date: new Date(),
              meta: { id: rid },
            };
            userTrackService(Userlogobj);
            return false;
            postService("", "POST", { data: { id: rid } }).then((res) => {
              let Userlogobjres = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "Edit Service - Response",
                date: new Date(),
                meta: res,
              };
              userTrackService(Userlogobjres);
              // console.log('response',res.data[0]);
              if (res.status) {
                // this.setState((state) => ({ tbody: res.data[0], loadding: false }));
                formSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "name") {
                    formSchema["feilds"][key]["value"] =
                      res.data[0]["username"];
                  }
                });
                this.setState({
                  addText: "Edit Service",
                  buttonText: "Update",
                  formData: servicesSchema["feilds"],
                });
              }
            });
          }
        );
        break;
      case "add-units":
        unitformSchema["feilds"].map((feild, key) => {
          unitformSchema["feilds"][key]["value"] = null;
          unitformSchema["feilds"][key]["disable"] = false;
          unitformSchema["feilds"][key]["valid"] = false;
          unitformSchema["feilds"][key]["errors"] = [];

          delete unitformSchema["feilds"][key]["text"];
        });
        this.setState({
          addText: "Add Unit",
          buttonText: "Submit",
          formData: unitformSchema["feilds"],
        });
        break;
      case "edit-units":
        this.setState(
          (state) => ({
            addText: "Edit Unit",
            buttonText: "Update",
            formData: unitformSchema["feilds"],
          }),
          () => {
            return false;
            postService("", "POST", {}).then((res) => {
              if (res.status) {
                unitformSchema["feilds"].map((feild, key) => {
                  if (feild["name"] === "name") {
                    unitformSchema["feilds"][key]["value"] =
                      res.data[0]["display_name"];
                  }
                  if (feild["name"] === "unit") {
                    unitformSchema["feilds"][key]["value"] =
                      res.data[0]["unit"];
                    unitformSchema["feilds"][key]["text"] =
                      res.data[0]["unit_name"];
                  }
                });
                this.setState({
                  addText: "Edit Unit",
                  buttonText: "Update",
                  formData: tvformSchema["feilds"],
                });
              }
            });
          }
        );
        break;
      default:
        break;
    }
  }

  componentWillUnmount() {
    this.setState({
      visible: false,
      formData: [],
      showPrevilages: false,
      unitsArray: [],
    });
    localStorage.removeItem("workstationbyunitid");
    // Storage.store('secretary_doctor',null);
  }
  handleCancel = (e) => {
 
    this.setState({ visible: false });
  };

  handleChange(ele) {
    const { slug } = this.props.match.params;
 

    if (slug === "add-user" || slug === "edit-user") {
      if (ele["name"] === "unit") {
        this.state.changedObj = ele;
        localStorage.setItem('workstationbyunitid', parseInt(ele.value))
      }
      let { formData } = this.state;
      formData.map((data, key) => {
        if (data["name"] === ele["name"]) {
          data["value"] = ele.value;
          data["valid"] = true;
          formData[key] = data;

          if (data["name"] === "role") {
            // co-ordinator role
            // Token Generator
            if (ele["value"] === "RL_J88m") {
              formData.map((feild, key) => {
                if (feild["id"] > 11) {
                  delete formData[key];
                }
                if (formData[key]["name"] === "work_station") {
                  formData[key]["visible"] = true;
                  formData[key]["value"] = [];
                  formData[key]["rules"] = [
                    {
                      test: (value) => {
                        return value !== null && value.length > 0;
                      },
                      message: "Please Select Workstation",
                    },
                  ];
                }
              });
            } else {
              formData.map((feild, key) => {
                if (feild["id"] > 11) {
                  delete formData[key];
                }
                if (formData[key]["name"] === "work_station") {
                  formData[key]["visible"] = false;
                  formData[key]["value"] = null;
                  formData[key]["rules"] = [];
                }
              });
            }
            // Doctor
            if (ele["value"] === "RL_fGhl") {
              formData.map((feild, key) => {
                if (feild["id"] > 11) {
                  delete formData[key];
                }
                if (formData[key]["name"] === "doctor_user_id") {
                  formData[key]["visible"] = true;
                  formData[key]["value"] = null;
                  formData[key]["rules"] = [
                    {
                      test: (value) => {
                        return value !== null && value.length > 0;
                      },
                      message: "Please Enter Doctor User ID",
                    },
                  ];
                }
              });
            } else {
              formData.map((feild, key) => {
                if (feild["id"] > 11) {
                  delete formData[key];
                }
                if (formData[key]["name"] === "doctor_user_id") {
                  formData[key]["visible"] = false;
                  formData[key]["value"] = null;
                  formData[key]["rules"] = [];
                }
              });
            }
            if (ele["value"] === "RL_LiGM") {
              formData.map((feild, key) => {
                if (feild["id"] > 11) {
                  delete formData[key];
                }
                if (formData[key]["name"] === "secretary_doctor_ids") {
                  formData[key]["visible"] = true;
                  formData[key]["value"] = null;
                  formData[key]["rules"] = [
                    {
                      test: (value) => {
                        return value !== null && value.length > 0;
                      },
                      message: "Please Enter Doctor ID",
                    },
                  ];
                }
              });
            } else {
              formData.map((feild, key) => {
                if (feild["id"] > 11) {
                  delete formData[key];
                }
                if (formData[key]["name"] === "secretary_doctor_ids") {
                  formData[key]["visible"] = false;
                  formData[key]["value"] = null;
                  formData[key]["text"] = null;
                  formData[key]["rules"] = [];
                }
              });
            }
            // Admin or Super Admin
            // if (ele["value"] === "RL_ijmN" || ele["value"] === "RL_uxwJ") {
            formData.map((feild, key) => {
              if (feild["id"] > 11) {
                delete formData[key];
              }
              if (formData[key]["name"] === "unit") {
                if (formData[key]["element"] === "Select2multiple") {
                  formData[key]["visible"] = true;
                  formData[key]["value"] = null;
                  formData[key]["rules"] = [
                    {
                      test: (value) => {
                        return value !== null && value.length > 0;
                      },
                      message: "Please Select Units",
                    },
                  ];
                }
                if (formData[key]["element"] === "select2") {
                  formData[key]["visible"] = false;
                  formData[key]["value"] = null;
                  formData[key]["text"] = null;
                  formData[key]["rules"] = [];
                }
              }
            });
            // }
            //  else {
            //   formData.map((feild, key) => {
            //     if (feild["id"] > 11) {
            //       delete formData[key];
            //     }
            //     if (formData[key]["element"] === "Select2multiple") {
            //       formData[key]["visible"] = false;
            //       formData[key]["value"] = null;
            //       formData[key]["text"] = null;
            //       formData[key]["rules"] = [];
            //     }
            //     // if (
            //     //   formData[key]["name"] === "unit" &&
            //     //   formData[key]["element"] === "select2"
            //     // ) {
            //     //   formData[key]["visible"] = true;
            //     //   formData[key]["value"] = null;
            //     //   formData[key]["rules"] = [
            //     //     {
            //     //       test: (value) => {
            //     //         return value !== null && value.length > 0;
            //     //       },
            //     //       message: "Please Select Unit",
            //     //     },
            //     //   ];
            //     // }
            //   });
            // }
          }
        }
      });
      console.clear();
  
      this.setState((state) => ({ date: new Date(), formData: formData }));
    }
    if (slug === "add-services") {
      let { formData } = this.state;
    
      formData.map((data, key) => {
        if (data["name"] === ele["name"]) {
          data["value"] = ele.value;
          data["valid"] = true;
          formData[key] = data;
        }
      });
      formData.map((feild, key) => {
        // if (feild["id"] > 11) {
        //   delete formData[key];
        // }
        if (formData[key]["name"] === "group") {
          if (formData[key]["element"] === "Select2") {
            formData[key]["visible"] = true;
            formData[key]["value"] = null;
            formData[key]["rules"] = [
              {
                test: (value) => {
                  return value !== null && value.length > 0;
                },
                message: "Please Select service group",
              },
            ];
          }
        }
      });
   
      this.setState((state) => ({ date: new Date(), formData: formData }));
    }
    if (slug === "addtvscreen" || slug === "edittvscreen") {
      let { formData } = this.state;
      formData.map((data, key) => {
        if (data["name"] === ele["name"]) {
          data["value"] = ele.value;
          data["text"] = ele.value;
          data["valid"] = true;
          formData[key] = data;

          if (data["name"] === "qCreateType") {
            if (ele["value"] !== "billing") {
              formData.map((item) => {
                if (item["name"] === "queues-list") {
                  item["visible"] = true;
                }
              });
            } else {
              formData.map((item) => {
                if (item["name"] === "queues-list") {
                  item["visible"] = false;
                }
              });
            }
          }
        }
      });
     
      this.setState((state) => ({ date: new Date(), formData: formData }));
    }
  }

  addUser() {
    let This = this;
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    const {
      createUser,
      createDoctor,
      updateUserDetailsById,
      updateDoctor,
      addWorkStation,
      checkDuplicateUser,
      updateWorkStation,
      addTvDisplay,
      updateTvDisplay,
      createUnit,
      createDepartment,
      createMasterService
    } = networkList;
    const { slug } = this.props.match.params;
    var formFeilds = this.state.formData;
    let errors = this.validateModalFeilds(formFeilds);
    let role_id = null;
  
    if (!errors.includes(false)) {
      // this.setState((state) => ({ loadding: true }));
      if (slug === "addtvscreen") {
        var data = {
          display_name: null,
          queue_list: [],
          unit: null,
          queue_type: null,
          work_station: null,
        };
        this.state.formData.map((sva, key) => {
          if (sva["name"] === "displayName") {
            data["display_name"] = sva["value"];
          }
          if (sva["name"] === "queues-list") {
            data["queue_list"] = sva["value"] ? sva["value"] : [];
            // sva.visible = false;
          }
          if (sva["name"] === "unit") {
            data["unit"] = sva["value"];
          }
          if (sva["name"] === "qCreateType") {
            data["queue_type"] = sva["value"];
          }
          if (sva["name"] === "workstation") {
            data["work_station"] = sva["value"];
          }
        });
     
        // return false;
        postService(addTvDisplay, "POST", { data: data }).then((res) => {
          let Userlogobjres = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Create User - Response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "Added Successfully",
              onOk: function () {
                This.props.history.push("/settings/tv-screens");
              },
            });
          } else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: "Something went wrong. Please,try again later",
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "edittvscreen") {
        let data = {
          id: null,
          tv_display_id: rid ? rid : null,
          display_name: null,
          queue_list: null,
          unit: null,
          queue_type: null,
          work_station: null,
        };
        this.state.formData.map((sva, key) => {
          if (sva["name"] === "displayName") {
            data["display_name"] = sva["value"];
            data["id"] = sva["tv_id"];
          }
          if (sva["name"] === "queues-list") {
            data["queue_list"] = sva["value"];
          }
          if (sva["name"] === "unit") {
            data["unit"] = sva["value"];
          }
          if (sva["name"] === "qCreateType") {
            data["queue_type"] = sva["value"];
          }
          if (sva["name"] === "workstation") {
            data["work_station"] = sva["value"];
          }
        });
      
        // return false;
        postService(updateTvDisplay, "POST", { data: data }).then((res) => {
          let Userlogobjres = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Edit Tvscreen - Response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "Updated Successfully",
              onOk: function () {
                This.props.history.push("/settings/tv-screens");
              },
            });
          } else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: "Something went wrong. Please,try again later",
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "add-services") {
        var data = {
          name: null,
          service_group_id: null,
          service_code: null,
        };
        this.state.formData.map((sva, key) => {
          if (sva["name"] === "Service") {
            data["name"] = sva["value"]
          }
          if (sva["name"] === "code") {
            data["service_code"] = sva["value"]
          }
          if (sva["name"] === "group") {
            data["service_group_id"] = sva["value"]
          }
        })
        postService(createMasterService, "POST", { data: data }).then((res) => {
          let Userlogobjres = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Add service Response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "Service Added Successfully",
              onOk: function () {
                This.props.history.push("/settings/services");
              },
            });
          }
          else if (!res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: res.data[0].message,
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
          else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: "Something went wrong. Please,try again later",
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "add-user") {
        var data = {
          name: null,
          password: null,
          role_id: null,
          access_type: null,
          unit: [],
          work_station: null,
          doctor_user_id: null,
        };
        this.state.formData.map((sva, key) => {
          if (sva["name"] === "userName") {
            data["name"] = sva["value"];
          }
          if (sva["name"] === "password") {
            data["password"] = sva["value"];
          }
          if (sva["name"] === "role") {
            data["role_id"] = sva["value"];
          }
          if (sva["name"] === "unit") {
            // if (data["role_id"] === "RL_uxwJ") {
            //   data["unit"] = sva["value"];
            // } else {
            //   data["unit"] = [sva["value"]];
            // }
            data["unit"] = sva["value"];
          }
          if (sva["name"] === "work_station") {
            data["work_station"] = sva["value"];
            sva.visible = false;
          }
          if (sva["name"] === "doctor_user_id") {
            if (sva["value"]) {
              data["doctor_user_id"] = sva["value"];
            } else {
              data["doctor_user_id"] = data["name"];
            }
            sva.visible = false;
          }
        });
     
        // return false;
        if (data.user_id !== null && data.user_id !== "") {
          try {
            postService(checkDuplicateUser, "POST", {
              username: data["name"],unitid:this.state.unit_id,
            }).then((res) => {
              if (res.status) {
                if (res.data === "0") {
                  postService(createUser, "POST", { data: data }).then(
                    (res) => {
                      let Userlogobjres = {
                        user: JSON.parse(localStorage.getItem("user")),
                        action: "Create User - Response",
                        date: new Date(),
                        meta: res,
                      };
                      userTrackService(Userlogobjres);
                      if (res.status) {
                        this.setState((state) => ({ loadding: false }));
                        Modal.success({
                          title: "Success message",
                          content: "User Added Successfully",
                          onOk: function () {
                            This.props.history.push("/settings/users");
                          },
                        });
                      } else {
                        this.setState((state) => ({ loadding: false }));
                        Modal.error({
                          title: "Error message",
                          content:
                            "Something went wrong. Please,try again later",
                          onOk: function () {
                            window.scrollTo(0, 0);
                          },
                        });
                      }
                    }
                  );
                } else {
                  Modal.error({
                    title: "Error message",
                    content: res.message,
                    onOk: function () {
                      window.scrollTo(0, 0);
                    },
                  });
                }
              }
            });
          } catch (error) {
       
            Modal.error({
              title: "Failure",
              content: "Oops, something went wrong... Please try again.",
            });
          }
        }
      }
      if (slug === "edit-user") {
        var data = {
          id: rid ? rid : null,
          name: null,
          password: null,
          role_id: null,
          unit: [],
          work_station: null,
          doctor_user_id: null,
        };
        formFeilds.map((sva, key) => {
          if (sva["name"] === "userName") {
            data["name"] = sva["value"];
          }
          if (sva["name"] === "password") {
            data["password"] = sva["value"];
          }
          if (sva["name"] === "unit") {
            // admin
            // if (data["role_id"] === "RL_uxwJ") {
            //   let unitids =
            //     sva["value"] && sva["value"].map((val) => val.unit_id);
            //   data["unit"] = unitids && unitids;
            // } else {
            //   data["unit"] = [sva["value"][0].unit_id];
            // }
            data["unit"] = sva["value"];
          }
          if (sva["name"] === "role") {
            data["role_id"] = sva["value"];
          }
          if (sva["name"] === "work_station") {
            data["work_station"] = sva["value"];
          }
          if (sva["name"] === "doctor_user_id") {
            if (sva["value"]) {
              data["doctor_user_id"] = sva["value"];
            } else {
              data["doctor_user_id"] = data["name"];
            }
          }
          let temp = [];
          if (sva["name"] === "otroom") {
            if (sva["value"].length > 0) {
              if (sva["value"][0]["id"] !== undefined) {
                sva["value"].map((types, key) => {
                  temp.push(types.id);
                });
                data["otroom"] = temp;
              } else {
                data["otroom"] = sva["value"];
              }
            } else {
              data["otroom"] = [];
            }

       
          }
          let temps = [];
          if (sva["name"] === "secretary_doctor_ids") {
            if (sva["value"].length > 0) {
              if (sva["value"][0]["id"] !== undefined) {
                sva["value"].map((types, key) => {
                  temps.push(types.id);
                });
                data["secretary_doctor_ids"] = temps;
              } else {
                data["secretary_doctor_ids"] = sva["value"];
              }
            } else {
              data["secretary_doctor_ids"] = [];
            }

       
          }
          // admin
          if (sva["name"] === "role_id" && sva["value"] === "RL_ijmN") {
            data["otroom"] = [];
        
          }
          // co-ordinator
          if (sva["name"] === "role_id" && sva["value"] === "RL_GXCM") {
      

            // formFeilds.map((feild, Feilskey) => {
            //     if (feild['name'] == 'otroom' && feild['element'] === 'Select2multiple' && feild['value'] !== null && feild['value']) {
            //         // data['otroom'].push(feild['name']);

            //     }
            // })
          }
        });
        console.clear();
     

        let Userlogobj = {
          user: JSON.parse(localStorage.getItem("user")),
          action: "Update User - Request",
          date: new Date(),
          meta: data,
        };
        userTrackService(Userlogobj);
        // return false;
        postService(updateUserDetailsById, "POST", { data: data }).then(
          (res) => {
            let Userlogobjres = {
              user: JSON.parse(localStorage.getItem("user")),
              action: "Update User - Response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            if (res.status) {
              this.setState((state) => ({ loadding: false }));
              Modal.success({
                title: "Success message",
                content: "User updated Successfully",
                onOk: function () {
                  This.props.history.push("/settings/users");
                },
              });
            } else {
              this.setState((state) => ({ loadding: false }));
              Modal.error({
                title: "Error message",
                content: "Something went wrong. Please,try again later",
                onOk: function () {
                  window.scrollTo(0, 0);
                },
              });
            }
          }
        );
      }
      if (slug === "add-doctor") {
        var data = {};
        formFeilds.map((sva, key) => {
          // if (sva["name"] !== "button" && sva["name"] !== "newDoctor") {
          //   data[sva["name"]] = sva["value"];
          // }

          if (sva["name"] === "doctorname") {
            data["doctor_name"] = sva["value"];
          }
          if (sva["name"] === "empid") {
            data["doctor_id"] = sva["value"];
          }
          if (sva["name"] === "department") {
            data["fk_department_id"] = sva["value"];
          }
          if (sva["name"] === "unit") {
            data["unit_code"] = sva["value"];
          }
          if (sva["name"] === "specialization") {
            data["specialization_code"] = sva["value"];
          }
          if (sva["name"] === "experience") {
            data["experience"] = sva["value"];
          }
          if (sva["name"] === "vitals_required"){
            if(sva["value"]===null){
              data["vitals_required"]=false;
            }
            else{
            data["vitals_required"]=sva["value"];}
          }
        });
        console.clear();
      
        // return false;
        let Userlogobj = {
          user: JSON.parse(localStorage.getItem("user")),
          action: "Create Doctor - Request",
          date: new Date(),
          meta: data,
        };
        userTrackService(Userlogobj);
        postService(createDoctor, "POST", { data: data }).then((res) => {
          let Userlogobjres = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Create Doctor - Response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "Doctor Added Successfully",
              onOk: function () {
                This.props.history.push("/settings/doctors");
              },
            });
          }
          else if (!res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: res.message,
              onOk: function () {
                // This.props.history.push("/settings/doctors");
                window.scrollTo(0, 0);
              },
            });
          }
          else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: "Something went wrong. Please,try again later",
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "edit-doctor") {
        var data = {
          id: rid ? Number(rid) : null,
          doctor_name: null,
          doctor_id: null,
          fk_department_id: null,
          unit_code: null,
          specialization_code: null,
          experience: null,
          vitals_required:null,
        };

        formFeilds.map((sva, key) => {
          // data[sva["name"]] = sva["value"];
          // if (sva["name"] === "role_id" && sva["value"] === "RL_HjPW") {
          //   formFeilds.map((feild, Feilskey) => {
          //     if (
          //       feild["id"] > 9 &&
          //       feild["element"] === "checkbox" &&
          //       feild["value"] !== null &&
          //       feild["value"]
          //     ) {
          //       data["privileges"].push(feild["name"]);
          //     }
          //   });
          // }
          // if (sva["name"] === "phonenumber") {
          //   data["phone_number"] = sva["value"];
          // }
          // if (sva["name"] === "role_id" && sva["value"] != "RL_HjPW") {
          //   data["privileges"] = [];
          // }

          if (sva["name"] === "doctorname") {
            data["doctor_name"] = sva["value"];
          }
          if (sva["name"] === "empid") {
            data["doctor_id"] = sva["value"];
          }
          if (sva["name"] === "unit") {
            data["unit_code"] = sva["value"];
          }
          if (sva["name"] === "specialization") {
            data["specialization_code"] = sva["value"];
          }
          if (sva["name"] === "department") {
            data["fk_department_id"] = sva["value"];
          }
          if (sva["name"] === "experience") {
            data["experience"] = sva["value"];
          }
          if (sva["name"] === "vitals_required"){
            if(sva["value"]===null){
              data["vitals_required"]=false;
            }
            else{
            data["vitals_required"]=sva["value"];}
          }
        });
  
        postService(updateDoctor, "POST", { data: data }).then((res) => {
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "Doctor Updated Successfully",
              onOk: function () {
                This.props.history.push("/settings/doctors");
              },
            });
          } else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: "Something went wrong. Please,try again later",
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "add-work-stations") {
        var data = {};
        formFeilds.map((sva, key) => {
          if (sva["name"] === "work_station_name") {
            data["work_station_name"] = sva["value"];
          }
          if (sva["name"] === "unit_id") {
            data["unit_id"] = sva["value"];
          }
          if (sva["name"] === "cabin_count") {
            data["cabin_count"] = sva["value"];
          }
        });
        postService(addWorkStation, "POST", { data }).then((res) => {
      
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "User Added Successfully",
              onOk: function () {
                This.props.history.push("/settings/work-stations");
              },
            });
          } else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: res.message,
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "edit-work-stations") {
        var data = {
          id: Number(rid),
          work_station_name: null,
          unit_id: null,
          cabin_count: null,
        };
        formFeilds.map((sva, key) => {
          if (sva["name"] === "work_station_name") {
            data["work_station_name"] = sva["value"];
          }
          if (sva["name"] === "unit_id") {
            data["unit_id"] = sva["value"];
          }
          if (sva["name"] === "cabin_count") {
            data["cabin_count"] = Number(sva["value"]);
          }
        });
        postService(updateWorkStation, "POST", { data }).then((res) => {
      
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: res.message,
              onOk: function () {
                This.props.history.push("/settings/work-stations");
              },
            });
          } else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: res.message,
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "add-units") {
        var data = {
          name: null,
          address: null,
        };
        this.state.formData.map((sva, key) => {
          if (sva["name"] === "name") {
            data["name"] = sva["value"];
          }
          if (sva["name"] === "address") {
            data["address"] = sva["value"];
          }
        });
     
        postService(createUnit, "POST", { data: data }).then((res) => {
          let Userlogobjres = {
            user: JSON.parse(localStorage.getItem("user")),
            action: "Create Doctor - Response",
            date: new Date(),
            meta: res,
          };
          userTrackService(Userlogobjres);
          if (res.status) {
            this.setState((state) => ({ loadding: false }));
            Modal.success({
              title: "Success message",
              content: "Unit Added Successfully",
              onOk: function () {
                This.props.history.push("/settings/units");
              },
            });
          } else {
            this.setState((state) => ({ loadding: false }));
            Modal.error({
              title: "Error message",
              content: "Something went wrong. Please,try again later",
              onOk: function () {
                window.scrollTo(0, 0);
              },
            });
          }
        });
      }
      if (slug === "edit-units") {
      }
    }
  }

  cancel() {
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    let { slug } = this.props.match.params;
    switch (slug) {
      case "addtvscreen":
      case "edittvscreen":
        this.props.history.push("/settings/tv-screens");
        break;
      case "add-user":
      case "edit-user":
        this.props.history.push("/settings/users");
        break;
      case "add-doctor":
      case "edit-doctor":
        this.props.history.push("/settings/doctors");
        break;
      case "add-work-stations":
      case "edit-work-stations":
        this.props.history.push(`/settings/work-stations`);
        break;
      case "add-service-group":
      case "edit-service-group":
        this.props.history.push(`/settings/service-group`);
        break;
      case "add-units":
      case "edit-units":
        this.props.history.push(`/settings/units`);
        break;
      case "add-departments":
      case "edit-departments":
        this.props.history.push(`/settings/departments`);
        break;
      case "add-services":
      case "edit-services":
        this.props.history.push(`/settings/services`);
        break;
      default:
        break;
    }
  }

  validateModalFeilds(formFeilds) {
    let errors = [];
    let role_id = null;
    formFeilds.map((feild, key) => {
      if (
        feild["element"] === "input" ||
        feild["element"] === "select2" ||
        feild["element"] === "date" ||
        feild["element"] === "time" ||
        feild["element"] === "Select2multiple"
      ) {
        if (feild["name"] === "role_id" && feild["value"] === "RL_HjPW") {
          role_id = true;
        } else {
          role_id = false;
        }
        formFeilds[key]["errors"] = [];
        if (!feild.disable) {
          feild.rules.map((rule, rkey) => {
            if (
              rule.test !== undefined &&
              typeof rule.test === "function" &&
              !rule.test(feild["value"])

            ) {
              if (feild["name"] === "otroom") {
                feild.rules.map((inloop, rkey) => {
                  if (
                    (inloop["name"] === "role_id" &&
                      inloop["value"] === "RL_GXCM") ||
                    inloop["value"] !== null ||
                    inloop["value"] !== "" ||
                    inloop["value"] !== undefined
                  ) {
                    if (
                      feild["value"] !== null ||
                      inloop["value"] !== undefined ||
                      inloop["value"] !== ""
                    ) {
                      formFeilds[key]["errors"].push({ message: rule.message });
                      errors.push(false);
                    } else {
                      errors.push(true);
                    }
                  }
                });
              } else if (
                feild["name"] === "doctorname" ||
                feild["name"] === "empid" ||
                feild["name"] === "unit" ||
                feild["name"] === "specialization" ||
                feild["name"] === "department" ||
                feild["name"] === "experience" ||
                feild["name"] === "Service" ||
                feild["name"] === "code" ||
                feild["name"] === "group"
              ) {
                if (feild["value"] === null) {
                  formFeilds[key]["errors"].push({ message: rule.message });
                  errors.push(false);
                } else {
                  errors.push(true);
                }
              } else if (
                feild["name"] === "qCreateType" ||
                feild["name"] === "queues-list" ||
                feild["name"] === "workstation"
              ) {
                if (feild["value"] === null && feild["visible"]) {
                  formFeilds[key]["errors"].push({ message: rule.message });
                  errors.push(false);
                } else {
                  errors.push(true);
                }
              }
            }
          });
        }
      }
      if (role_id !== null && role_id) {
      }
    });

    this.setState((state) => ({ formData: formFeilds }));
    return errors;
  }

  getMapped_UnitsOfUser() {
    let all_tokens = Storage.get("all_tokens");
    let all_tokens_details = all_tokens && JSON.parse(all_tokens);
    let newData = [];
    if (all_tokens_details.length !== 0) {
      all_tokens_details.map((rdata, rKey) => {
        newData.push({
          'id': rdata['unit_id'],
          'name': rdata['unit_name']
        })
      })
    }
    this.setState((state) => ({ 'mappedUnits': newData }));
  }

  unit_change(value) {
    const { formData } = this.state;
   

    formData.map((data, key) => {
      if (data["name"] === "unit" && data["element"] === "Select2multiple") {
        formData[key]["value"] = value;
        formData[key]["valid"] = false;
      }
    })
    this.setState({ active_units: value, formData: formData })
  }

  handle2Change = ({ fileList }) => {

    let file = null,
      file_type = null,
      file_name = null,
      file_size = null;
    if (fileList) {
      // fileList.map(async(item, key) =>
      for (let i = 0; i < fileList.length; i++) {
        let item = fileList[i]
        let key = i
        // fileList[key]['status'] = 'done';
        // fileList[key]['base_64'] = await getBase64(file.originFileObj);            
        file = item.originFileObj;
        file_type = item.type;
        file_name = item.name;
        file_size = item.size;
        // check file type
        const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg';

        const isLt2M = file_size / 300 / 300 < 2;
        if (!isJpgOrPngOrPdf) {
          Modal.error({
            title: `(${file_name}) is invalid file.`,
            content: `Please, upload the following extensions files (.png/.jpg) smaller than 300KB only.`,
            zIndex: '1022'
          });
        }
        // check file size        
        else if (!isLt2M) {
          Modal.error({
            title: `(${file_name}) is invalid file.`,
            content: `Please, upload the file smaller than 300KB only.`,
            zIndex: '1022'
          });
        }

        else {
      
          this.resubmit(file)

        }
      }
      // );
    }

  };
  resubmit = (file) => {
    this.setState({ loadding: true })
    let user_data = null
    const { id, slug } = this.props.match.params;
    if (localStorage.getItem('user_data') !== null) {
      user_data = JSON.parse(localStorage.getItem('user_data'))
    } else {
      Modal.error({
        title: `Failure`,
        content: `unit in null.`,
        zIndex: '1022'
      });
    }
    let { body } = this.state
    if (file && body && body.id) {
      let doctorname = body.name.replace(/\s/g, '');
      var num = body.id;
      var doc_id = num.toString();
      var form_data = new FormData();
      form_data.append('upfile', file);
      form_data.append("doctorid", body.id);
      form_data.append("doctorName", doctorname + '.jpg');
      if (body.profile_pic !== null && body.profile_pic !== '' && body.profile_pic !== undefined) {
        let This = this
        Modal.confirm({
          title: `Confirmation`,
          content: `Are you sure you want to upload a new image?`,
          zIndex: '1022',
          okText: "Ok",
          cancelText: "Cancel",
          onOk: function () {
            try {
              formDataPostService('profileUploadForDoctor', 'POST', form_data).then(res => {

                if (res.status) {
                  Modal.success({
                    title: `success`,
                    content: `${res.message}`,
                    zIndex: '1022',
                    okText: "Ok",
                    onOk: function () {
                      This.cancel();
                      This.setState({ loadding: false })
                    }
                  });
                } else {
                  Modal.error({
                    title: `Failure`,
                    content: `${res.message}`,
                    zIndex: '1022'
                  });
                  This.setState({ loadding: false })
                }

              })
            } catch (error) {
            
              this.setState((state) => ({ 'loadding': false }));
              Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
                zIndex: '1022'
              })

            }
          }
          ,
          onCancel() {
         
            This.setState({ loadding: false })
          },
        });
      } else {
        let This = this
        try {
          formDataPostService('profileUploadForDoctor', 'POST', form_data).then(res => {
            if (res.status) {
              Modal.success({
                title: `success`,
                content: `${res.message}`,
                zIndex: '1022',
                okText: "Ok",
                onOk: function () {
                  This.cancel();
                  This.setState({ loadding: false })
                }
              });

            } else {
              Modal.error({
                title: `Failure`,
                content: `${res.message}`,
                zIndex: '1022'
              });
              This.setState({ loadding: false })
            }

          })
        } catch (error) {
       
          this.setState((state) => ({ 'loadding': false }));
          Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
            zIndex: '1022'
          })

        }
      }

    } else {
      Modal.error({
        title: `Failure`,
        content: `Oops, something went wrong. Please try again.`,
        zIndex: '1022'
      });
      this.setState({ loadding: false })
    }

  }


  render() {
    let { showPrevilages, formData, addText, buttonText, active_units, fetching, mappedUnits, fileList, doctorData } = this.state;

    let { doctor_profile_url } = networkList;
    return (
      <div>
        <Spin spinning={this.state.loadding}>
          <div className="card pt-3 pb-5 mt-3 mx-5">
            <h1 className="text-center text-capitalize text-heading mb-0">
              {addText} 
            </h1>
            <div className="row pt-2 pl-5 pr-5 justify-content-center">
              {formData !== undefined && (
                <div className="col-5">
                  {formData.map((feild, key) => {
                    if (feild.element === "input" && feild.visible) {
                      return (
                        <div
                          className={`${feild.className ? feild.className : "col"
                            } my-2 ${feild.name}`}
                          key={key}
                        >
                          <p className="data-label w-100 mb-1 pt-2">
                            {feild.title}
                          </p>
                          
                          {feild.name === "vitals_required"?(<div className="checkbox-container"><span className="vitals-label">Vitals :</span> <Inputlayer
                            {...this.props}
                            {...this.state}
                            feildData={feild}
                            onInputChanges={this.handleChange.bind(this)}
                          /></div>):( <Inputlayer
                            {...this.props}
                            {...this.state}
                            feildData={feild}
                            onInputChanges={this.handleChange.bind(this)}
                          />)}
                        
                        </div>
                      );
                    }
                    if (feild.element === "select2" && feild.visible) {
                      return (
                        <React.Fragment key={key}>
                          {feild.name === "patient_list" &&
                            feild.disable === false && (
                              <div className="col-6">
                                <p
                                  className="mb-0 text-black pl-0"
                                  style={{
                                    fontSize: 13 + "px",
                                    lineHeight: 2,
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  <span
                                    className="text-info"
                                    style={{
                                      fontSize: 15 + "px",
                                      lineHeight: 2,
                                    }}
                                  >
                                    Note:
                                  </span>{" "}
                                  Please Select Patient List
                                </p>
                              </div>
                            )}

                          <div
                            className={`${feild.className ? feild.className : "col "
                              } my-2 ${feild.name}`}
                            key={key}
                          >
                            <div className="clearfix">
                              <p className="data-label w-100 mb-1 pt-2">
                                {feild.title}
                              </p>
                            </div>
                            <Select2
                              selectdata={feild}
                              changedObj={this.state.changedObj}
                              {...this.props}
                              {...this.state}
                              Queuedata={this.state.formData}
                              onselectChanges={this.handleChange.bind(this)}
                            />
                            {feild.errors.map((error, eKey) => {
                              return (
                                <small key={eKey} className="text-danger">
                                  {error.message}
                                </small>
                              );
                            })}
                          </div>
                        </React.Fragment>
                      );
                    }
                    if (feild.element === "Select2multiple" && feild.visible) {
                      if (feild.name === 'unit') {
                        return (
                          <React.Fragment key={key}>
                            <div
                              className={`${feild.className ? feild.className : "col "
                                } my-2 ${feild.name}`}
                              key={key}
                            >
                              <p className="data-label w-100 mb-1 pt-2">
                                {feild.title}
                              </p>
                              <Select mode="multiple" showSearch placeholder="Select Unit" optionFilterProp="children" value={active_units} onChange={this.unit_change.bind(this)} notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />} style={{ width: "100%" }} >
                                {mappedUnits && mappedUnits.map((data, key) => {
                                  return <Option key={key} value={data['id']}>{data['name']}</Option>
                                })}
                              </Select>
                              {feild.errors.map((error, eKey) => {
                                return (
                                  <small
                                    key={eKey}
                                    className="form-text text-danger"
                                  >
                                    {error.message}
                                  </small>
                                );
                              })}
                            </div>
                          </React.Fragment>
                        );
                      } else {
                        return (
                          <React.Fragment key={key}>
                            <div
                              className={`${feild.className ? feild.className : "col "
                                } my-2 ${feild.name}`}
                              key={key}
                            >
                              <p className="data-label w-100 mb-1 pt-2">
                                {feild.title}
                              </p>
                              <Select2multiple
                                Queuedata={formData}
                                selectdata={feild}
                                {...this.props}
                                {...this.state}
                                onselectChanges={this.handleChange.bind(
                                  this,
                                  feild
                                )}
                              />{" "}
                              {feild.errors.map((error, eKey) => {
                                return (
                                  <small
                                    key={eKey}
                                    className="form-text text-danger"
                                  >
                                    {error.message}
                                  </small>
                                );
                              })}
                            </div>
                          </React.Fragment>
                        );
                      }

                    }
                    if (feild.element === "date" && feild.visible) {
                      return (
                        <div
                          className={`${feild.className ? feild.className : "col "
                            } my-2 ${feild.name}`}
                          key={key}
                        >
                          <p className="data-label w-100 mb-1 pt-2">
                            {feild.title}
                          </p>
                          <Datepicker
                            // Queuedata={filtereData}
                            selectdata={feild}
                            {...this.props}
                            {...this.state}
                            onselectChanges={this.handleChange.bind(this)}
                          // onselectChanges={this
                          //     .onChange
                          //     .bind(this)}
                          />
                          {feild.errors.map((error, eKey) => {
                            return (
                              <small
                                key={eKey}
                                className="form-text text-danger"
                              >
                                {error.message}
                              </small>
                            );
                          })}
                        </div>
                      );
                    }
                    if (feild.element === "time" && feild.visible) {
                      return (
                        <div
                          className={`${feild.className ? feild.className : "col "
                            } my-2 ${feild.name}`}
                          key={key}
                        >
                          <p className="data-label w-100 mb-1 pt-2">
                            {feild.title}
                          </p>
                          <TimepickerLayer
                            selectdata={feild}
                            {...this.props}
                            {...this.state}
                            key={feild.title}
                            onselectChanges={this.handleChange.bind(this)}
                          />
                          {feild.errors.map((error, eKey) => {
                            return (
                              <small
                                key={eKey}
                                className="form-text text-danger"
                              >
                                {error.message}
                              </small>
                            );
                          })}
                        </div>
                      );
                    }
                    if (feild.element === "file" && feild.visible) {
                      return (
                        <div
                          className={`${feild.className ? feild.className : "col"
                            } my-2 ${feild.name}`}
                          key={key}
                        >
                          <p className="data-label w-100 mb-1 pt-2">
                            {feild.title}
                          </p>
                          <div className="row">
                            <div className="col-2">
                              <Upload action={null} fileList={fileList} onChange={this.handle2Change} beforeUpload={(file) => { this.setState({ body: doctorData }) }}>
                                <Tooltip title="Click here to upload">
                                  <CloudUploadOutlined className={doctorData && doctorData.profile_pic !== null && doctorData.profile_pic !== '' && doctorData.profile_pic !== undefined ? "profile_pic profile_green" : "profile_pic"} />
                                  {/* <AntCloudOutlined /></Button> */}
                                  {/* <Button><i class="fa fa-cloud-upload" aria-hidden="true"></i></Button> */}

                                </Tooltip>
                              </Upload>
                            </div>
                            <div className="col-8">
                              <img
                                alt=""
                                src={
                                  doctorData && doctorData.profile_pic
                                    ? doctor_profile_url + doctorData.profile_pic + '?' + new Date().getTime()
                                    : "/assets/images/newProfile.png"
                                }
                                className="edit_doctor_profile_pic"
                              />
                            </div>

                          </div>


                        </div>
                      );
                    }
                  })}
                </div>
              )}
            </div>
            {showPrevilages && (
              <div className="row pl-5 pr-5 align-items-end">
                {formData.map((feild, key) => {
                  if (feild.element === "checkbox") {
                    return (
                      <div
                        className={`${feild.className ? feild.className : "col"
                          } my-2 ${feild.name}`}
                        key={key}
                      >
                        <input
                          type="checkbox"
                          name={feild.id}
                          value={feild.value}
                          checked={feild.value}
                          onChange={(e) =>
                            this.handleChange({
                              name: feild.name,
                              value: feild.value ? false : true,
                            })
                          }
                        />{" "}
                        <label for={feild.text} className="data-label w-75">
                          {" "}
                          {feild.text}
                        </label>
                      </div>
                    );
                  }
                })}
              </div>
            )}
            <div className="row justify-content-center mt-4">
              <button
                className="btn btn-success text-capitalize mr-3"
                onClick={this.addUser.bind(this)}
              >
                {buttonText}
              </button>
              <button
                className="btn btn-red px-4 text-capitalize"
                onClick={this.cancel.bind(this)}
              >
                cancel
              </button>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}
export default Add_User;
